import { OktaSignIn } from '../oie';

// CDN bundle must have a single default export
export default OktaSignIn;
